import { Component, OnInit, Input } from "@angular/core";
import { WareHouseItemViewModel } from "src/app/viewmodels/g-item/GItemDefiningViewModel";
import { BsModalRef } from "ngx-bootstrap/modal";
import { UnitOfWorkService } from "src/app/services/api/uow/unit-of-work.service";
import Swal from "sweetalert2";
import { JqHelper } from "src/app/common/jq-helper";
import { NgxSpinnerService } from "ngx-spinner";
import { ItemViewModel } from 'src/app/viewmodels/ItemViewModel';
@Component({
  selector: "app-warehouse-item",
  templateUrl: "./warehouse-item.component.html",
  styleUrls: ["./warehouse-item.component.scss"],
})
export class WarehouseItemComponent implements OnInit {
  @Input() public vm: WareHouseItemViewModel;
  public list: WareHouseItemViewModel[] = [];
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  public itemId:number;
  public wareHouesList: Array<any> = [];
  public readOnlyFlag: boolean = false;
  public isDuplicate: boolean = false;
  public editMode: boolean[] = [];

  constructor(
    private _uow: UnitOfWorkService,
    private _jq: JqHelper,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    debugger
    
    this.itemId= this.vm.FK_Item_Id.Id;
    // this.getList();
    this.getwareHouseItemList(this.itemId);
    this.editMode = new Array(this.list.length).fill(false);
    debugger
    this.vm.MinStock= null;
    this.vm.MaxStock = null;
    
  }

  getwareHouseItemList(id) {
    debugger
    this.list = [];
    this._uow.gSettingService
      .GetWareHouseItemsAsync(id)
      .subscribe((res: any) => {
        debugger
        console.log("list ware house item", res);
        this.list = res.result;
        this.editMode = new Array(this.list.length).fill(false);
      });
  }

  onUpdateButtonForEdit(index: number): void {
    debugger
    // Toggle the edit mode for the selected row
    this.editMode[index] = !this.editMode[index];
}
  // getList() {
  //   this._uow.warehouseService.GetListByUserId().subscribe(
  //     (res: any) => {
  //       debugger
  //       this.wareHouesList = res;
  //       console.log(res);
  //       // this.spinner.hide();
  //       // this._jq.showSpinner();
  //     },
  //     (err) => {
  //       console.log(err);
  //       // this.spinner.hide();
  //     }
  //   );
  // }
  // public duplicateFlag: boolean = false;
  // findDuplication() {
  //   this.duplicateFlag = false;

  //   for (let i of this.list) {
  //     if (i.FK_WareHouse_Id.Id == this.vm.FK_WareHouse_Id.Id) {
  //       console.log("fid duplicate ");
  //       this.duplicateFlag = true;
  //     }
  //   }
  //   if (this.duplicateFlag) {
  //     this.isDuplicate = true;
  //   } else {
  //     this.isDuplicate = false;
  //   }
  // }
  // isDuplicateOrder(flag) {
  //   return flag;
  // }
  // saveOrUpdate() {
  //   this.spinner.show();
  //   console.log(this.vm);
  //   this._uow.wareHouseItemService
  //     .SaveG_WareHouseItem(this.vm)
  //     .toPromise()
  //     .then((res: any) => {
  //       console.log(res);
  //       this.spinner.hide();
  //       // this.vm = new WareHouseItemViewModel();
  //       this.getwareHouseItemList(this.itemId);
  //       // this.bsmRef.hide();
  //       Swal.fire("Created!", "Ware House Item Created/Updated!", "success");
  //     })
  //     .catch((error) => {
  //       this.spinner.hide();
  //       Swal.fire("Failure!", "Ware House Item Not Created/Updated!", "error");
  //       console.log(`Promise rejected with ${JSON.stringify(error)}`);
  //     });
  // }

  saveOrEdit() {
    debugger
    this.spinner.show();
    this.list = this.list.filter((item, index) => this.editMode[index]);
    this._uow.gSettingService
      .SaveWareHouseItemsAsync(this.list)
      .toPromise()
      .then((res: any) => {
        debugger
        console.log(res);
        this.spinner.hide();
        this.getwareHouseItemList(this.itemId);
        Swal.fire("Update!", "Ware House Item Updated!", "success");
      })
      .catch((error) => {
        this.spinner.hide();
        Swal.fire("Failure!", error.error.message, "error");
        console.log(`Promise rejected with ${JSON.stringify(error)}`);
      });
  }
  
  // onUpdateButtonClicked(item) {
  //   this.isDuplicate = false;
  //   let selectedWarehouse:any=[];
  //   this.vm = item;
  //   // this.itemId = this.vm.FK_Item_Id.Id;
  //   this.vm.FK_WareHouse_Id =new ItemViewModel(item.FK_WareHouse_Id.Id, item.FK_WareHouse_Id.Name);
  //   if(item.FK_WareHouse_Id != null && item.FK_WareHouse_Id != undefined){
  //     // let wh = new ItemViewModel();
  //     // wh.Id=;
  //     console.log(item);
  //     // wh.Name =item.FK_WareHouse_Id.Name;
  //     selectedWarehouse.push({FK_WareHouse_Id:this.vm.FK_WareHouse_Id});
  //      this.wareHouesList = selectedWarehouse;
  //      console.log(this.wareHouesList);
  //   }
  //   this.readOnlyFlag = true;
  // }
}
